import { useSearchParams } from "react-router-dom";

import { StarSVGIcon } from "@braintrust/braintrust-ui-components/Icons";
import { FilterPopover } from "@js/apps/employer/components/filter-popover";
import { useParsedQueryParamsWithDefaults } from "@js/hooks/parsed-query-params";
import { useFilterPopover } from "@js/hooks/use-filter-popover";
import { clearEmpties } from "@js/utils/data";

import type { TalentFeedbackFilters } from "../../config";
import { defaultFeedback, feedbackParamsSchema } from "../../config";

import { TalentFeedbackForm } from "./feedback-form";

export const FeedbackFilter = () => {
  const [, setSearchParams] = useSearchParams();
  const { data } = useParsedQueryParamsWithDefaults(
    feedbackParamsSchema,
    defaultFeedback,
  );
  const hasBeenHired = data?.has_been_hired;
  const highRating = data?.high_rating;
  const isApplied = !!hasBeenHired || !!highRating;

  const { isOpen, handleClick, handleClose, anchorElement } =
    useFilterPopover();

  const handleApply = (values: TalentFeedbackFilters) => {
    setSearchParams(
      (prev) => {
        const preparedValues = prepareValuesForParams(values);
        const currentParams = Object.fromEntries(prev.entries());
        const newParams = clearEmpties({
          ...currentParams,
          ...preparedValues,
        }) as Record<string, string>;

        return new URLSearchParams(newParams);
      },
      {
        state: { disableRemountIfTheSameLocation: true },
      },
    );
    handleClose();
  };

  return (
    <FilterPopover
      label={"Feedback"}
      icon={<StarSVGIcon />}
      isFilterApplied={isApplied}
      isFilterOpen={isOpen}
      onClick={handleClick}
      onClose={handleClose}
      anchorElement={anchorElement}
      variant="violet"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <TalentFeedbackForm values={data} onApply={handleApply} />
    </FilterPopover>
  );
};
const prepareValuesForParams = (valuesToPrepare: Record<string, unknown>) => {
  const parsedValues: Record<string, string | undefined> = {};

  Object.entries(valuesToPrepare).forEach(([key, value]) => {
    if (value) {
      parsedValues[key] = String(value);
    } else {
      parsedValues[key] = undefined;
    }
  });

  return parsedValues;
};
